export default __webpack_public_path__ + "static/combine-modify-c95e76e2a7f3ca73a77a90c873b28c5a.gif";